class ComponentSustainabilityPanels extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll('.panels-list .panel .btn');
        this.initButtons();
    }

    initButtons() {
        this.buttons.forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault();
                var panelEl = button.parentNode.parentNode;
                if (panelEl.classList.contains('active')) {
                    panelEl.classList.remove('active');
                } else {
                    panelEl.classList.add('active');
                }
            }, false)
        })
    }

}
customElements.define('sustainability-panels', ComponentSustainabilityPanels);